
import React from 'react'
import { Avatar, Input } from 'rsuite'
import styled from 'styled-components'
import { colors, fonts } from '../Styles/common-styles'
import defaultAvatar from '../../Components/Styles/images/Avatar_placeholder.png'
import { useAuth } from '../../Context/Auth'

const SaveButton = styled.button`
  background: ${colors.purpleBright};
  font-weight: 600;
  font-size: ${fonts.normalSize};
  line-height: 18px;
  color: #fff;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 11px 18px;
  &:hover {
    background: ${colors.purpleMain};
  }
`

const inputStyles = {
  marginTop: 32,
  marginLeft: 15
}

const textStyles = {
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '24px',
  color: colors.black
}

const Profile = () => {
  const { currentUser } = useAuth()
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ display: 'flex', flexDirection: 'column', width: '370px' }}>

        <div style={inputStyles}>
          <span style={textStyles}>Name</span>
          <Input placeholder='User name' value={currentUser.displayName} />
        </div>

        <div style={inputStyles}>
          <span style={textStyles}>Email</span>
          <Input placeholder='Email' value={currentUser.email} type='email' />
        </div>

        <div style={inputStyles}>
          <span style={textStyles}>Organisation (optional)</span>
          <Input placeholder={'Your Organisation\'s name'} />
        </div>

        <div style={inputStyles}>
          <span style={textStyles}>Your role (optional)</span>
          <Input placeholder='E.g. coach, facilitator, ...' />
        </div>

        <SaveButton style={{ margin: '44px 0 0 15px' }}>Save changes</SaveButton>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', marginTop: '42px', marginLeft: '30px', cursor: 'pointer' }}>
        <Avatar
          circle
          src={defaultAvatar}
          alt='UN'
          size='lg'
        />
        <span style={{ color: colors.purpleMain, fontSize: fonts.normalSize }}>Change</span>
      </div>
    </div>
  )
}

export default Profile
